import React from "react";

const RJChokhiSystem = () => {
  const images = [
    {
      src: "https://secondhomemds.com/wp-content/uploads/2024/02/WhatsApp-Image-2024-01-29-at-7.17.07-PM-1536x1152.jpeg",
      alt: "Family Dining Rajasthani Style",
    },
    {
      src: "https://secondhomemds.com/wp-content/uploads/2024/11/WhatsApp-Image-2024-11-23-at-3.12.14-PM-3-1469x1536.jpeg",
      alt: "Rajasthani Thali",
    },
    {
      src: "https://secondhomemds.com/wp-content/uploads/2024/02/WhatsApp-Image-2024-02-03-at-11.44.34-PM-1536x1023.jpeg",
      alt: "Rajasthani Food on Leaf Plates",
    },
  ];

  return (
    <div className="py-16 bg-gradient-to-b from-cream to-white px-4 sm:px-8">
      <div className="text-center mb-12">
        <h5 className="text-primary-dark font-semibold uppercase tracking-widest text-sm mb-2">
          Taste of Rajasthan
        </h5>
        <h1 className="font-display text-4xl font-bold text-gray-800">
          Traditional Rajasthani Delights
        </h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {images.map((img, idx) => (
          <div
            key={idx}
            className="group relative overflow-hidden  rounded-xl shadow-lg transition-all duration-700 hover:shadow-primary/30 hover:shadow-2xl animate-fade-in"
            style={{
              animationDelay: `${idx * 200}ms`,
              animationFillMode: "both",
            }}
          >
            {/* Glow Top Border */}
            <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-primary to-primary-light opacity-0 group-hover:opacity-100 transition-all duration-500"></div>

            {/* Image */}
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-80 object-cover transform transition-all duration-700 group-hover:scale-105 group-hover:rotate-1 group-hover:translate-y-1"
            />

            {/* Dark overlay tint */}
            <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-all duration-500"></div>

            {/* Caption text */}
            <div className="absolute bottom-4 left-1/2 min-w-max text-center transform -translate-x-1/2 translate-y-8 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-700 text-white text-sm bg-primary-dark/80 px-4 py-1 rounded-full shadow-md">
              {img.alt}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RJChokhiSystem;
